import axios from "axios";

const tokens = {};

/**
 * Generate token for cancellable request.
 *
 * @param {String} name The cancellable string that we register
 * cancellable token from.
 * @return {Object} The axios cancel token ready to be used.
 */
function generate(name) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    if (!tokens.hasOwnProperty(name)) {
        tokens[name] = [];
    }

    tokens[name].push(source);
    return source;
}

/**
 * Return all tokens binded to given name.
 *
 * @param {String} name The name to release.
 * @return {Array} The list of tokens stored for name.
 */
function get(name) {
    if (tokens.hasOwnProperty(name)) {
        return tokens[name];
    }
    return [];
}

/**
 * Return all tokens binded to given name (and delete them).
 *
 * @param {String} name The name to release.
 * @return {Array} The list of tokens stored for name.
 */
function release(name) {
    if (tokens.hasOwnProperty(name)) {
        const clone = tokens[name].slice(0);
        delete tokens[name];
        return clone;
    }
    return [];
}

/**
 * Cancel all previous requests waiting (if any).
 *
 * @param {String} name The token name.
 * @param {String | undefined} message The message when cancelling (if any).
 */
function cancel(name, message) {
    if (tokens.hasOwnProperty(name)) {
        const m = message || "Operation canceled by the user.";
        const t = tokens[name];
        for (let i = 0, l = t.length; i < l; i++) {
            t[i].cancel(m);
        }
        delete tokens[name];
    }
}

export default {
    generate: generate,
    release: release,
    get: get,
    cancel: cancel
};